import Member from "../member/member";

export default class LoginResponse {
  member: Member | null = null;
  error: boolean = false;
}
